import { Module } from 'vuex';
import { RootStore, Pages } from '@/main/store/@types/store.d';

export const pages: Module<Pages, RootStore> = {
	namespaced: true,
	state: {} as Pages,
};
